
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendors/deals/[id]",
      function () {
        return require("private-next-pages/vendors/deals/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendors/deals/[id]"])
      });
    }
  